"use client"
import {
  MultiSelect
} from "./chunk-2ICYBDUT.mjs";
import {
  Input
} from "./chunk-YYT6SG4M.mjs";

// src/components/date-picker.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var DatePicker = mergeMultiStyle(
  Input,
  MultiSelect,
  {
    baseStyle: {
      container: {},
      content: {
        minW: "auto",
        p: "2",
        w: "auto"
      },
      field: {
        cursor: "text",
        pb: "px",
        _focus: {
          zIndex: "unset"
        },
        _notAllowed: {
          cursor: "pointer"
        },
        _readOnly: {
          pointerEvents: "none"
        }
      }
    },
    sizes: {
      xs: {
        icon: {
          fontSize: "sm",
          pt: "2"
        }
      },
      sm: {
        icon: {
          fontSize: "lg"
        }
      }
    }
  }
)({
  omit: [
    "addon",
    "element",
    "group",
    "groupLabel",
    "header",
    "footer",
    "list",
    "item",
    "itemIcon"
  ]
});

export {
  DatePicker
};
//# sourceMappingURL=chunk-5TQUTEMZ.mjs.map